import ActionTypes from 'app/error/ActionTypes';

const actions = {
  addError(error, options = {}) {
    return {
      ...options,
      type: ActionTypes.ADD_ERROR,
      error,
    };
  },
  clearError(error) {
    return {
      type: ActionTypes.CLEAR_ERROR,
      error,
    };
  },
  clearErrors() {
    return {
      type: ActionTypes.CLEAR_ERRORS,
    };
  },
};

export default actions;
